import React, { useEffect, useState } from "react";
import { ArrowLeftIcon, HomeIcon } from "@heroicons/react/24/outline";
import LoadingSpinner from "./LoadingSpinner";

interface Props {
  link: string;
  phone?: string;
  onClose: () => void;
}

const VoltMoneyModal: React.FC<Props> = ({ link, phone, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [frameKey, setFrameKey] = useState(0);

  // FloatingTabBar hides itself on these events
  useEffect(() => {
    window.dispatchEvent(new CustomEvent("webViewOpen"));
    return () => {
      window.dispatchEvent(new CustomEvent("webViewClose"));
    };
  }, []);

  // ponytail: cross-origin iframe history can't be controlled, so back closes and home reloads the start link
  const goHome = () => {
    setLoading(true);
    setFrameKey((k) => k + 1);
  };

  return (
    <div className="fixed inset-0 z-[70] bg-white flex flex-col">
      <div className="flex items-center justify-between p-4 border-b">
        <button onClick={onClose} aria-label="Back"><ArrowLeftIcon className="h-6 w-6" /></button>
        <h2 className="font-semibold text-gray-900">Credit Line Application</h2>
        <button onClick={goHome} aria-label="Home"><HomeIcon className="h-6 w-6" /></button>
      </div>
      <div className="relative flex-1">
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center"><LoadingSpinner size="lg" /></div>
        )}
        <iframe
          key={frameKey}
          src={link}
          title="Volt Money"
          className="w-full h-full border-0"
          allow="camera; microphone; geolocation; clipboard-write"
          onLoad={() => setLoading(false)}
        />
      </div>
      <div className="flex items-center justify-between px-4 py-3 border-t text-sm">
        <span className="text-gray-600">Applying as: <span className="font-medium text-gray-900">{phone || "-"}</span></span>
        <button
          onClick={() => window.open(link, "_blank", "noopener,noreferrer")}
          className="font-medium text-[#129481]"
        >
          Open in new tab
        </button>
      </div>
    </div>
  );
};

export default VoltMoneyModal;
